

















































import CategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/CategoryResponse";
import { Vue, Component, Inject } from "vue-property-decorator";
import { LEVEL_CREATE, LEVEL_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import LevelResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Level/LevelResponse";
import { LevelFilterModel } from "@models/level";


@Component
export default class PageLevelsComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: LevelFilterModel = new LevelFilterModel();
  columnNames = ["#", "Название", "Кол-во минут для достижения", "Дата создания", "", ""];
  createRouteName = LEVEL_CREATE;
  editRouteName = LEVEL_EDIT;
  levels: LevelResponse[] = [];
  currentLevel: LevelResponse = null;

  getDataFunc = this.$api.LevelService.getListAsync.bind(
    this.$api.LevelService
  );

  removeFunc = this.$api.LevelService.deleteLevelAsync.bind(
    this.$api.LevelService
  );

  async created() {}

  async startDelete(item: CategoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
